import {observer} from "mobx-react-lite";
import { action, observable } from 'mobx';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Calculator } from 'react-bootstrap-icons'
import './InputWithSlider.scss';
import { useEffect, useRef } from "react";

type InputWithSliderProps = {
    placeholder: string,
    observable: any,
    field: string
    min: number,
    max: number,
    step: number,
    onChangeCallback: Function,
    defaultDisabled?: boolean,
    disableBtn?: boolean,
    errorMessage?: string
    dontShowSlider?: boolean,
    textAfterInput?: string,
    showDecimals?: boolean,
    disabled?: boolean,
    round?: boolean,
    buttonTooltip?: string,
    disableNumericalInput?: boolean
}

export const InputWithSlider = observer((props:InputWithSliderProps) => {

    const textInputRef = useRef<HTMLInputElement | null>(null);

    const onBlur = action((value: React.FocusEvent<HTMLInputElement>, observable: any, field: any) => {
        doChangeValue(value, observable, field);
        props.onChangeCallback(value);
    })

    const changeValue = action((value: React.ChangeEvent<HTMLInputElement>, observable: any, field: any) => {
        doChangeValue(value, observable, field);
        if (textInputRef.current) {
            textInputRef.current.value = value.target.value;
        }
        props.onChangeCallback(value);
    })

    function doChangeValue(event: React.ChangeEvent<HTMLInputElement>, observable: any, field: any){
        const value = event.target.value;
        const valueWithoutSpaces = value.replace(/\s/g, '');
        let valueWithDecimals = valueWithoutSpaces.replace(/,/g, '.');
        let num = Number(valueWithDecimals);
        if (isNaN(num)) {
            return;
        }

        let result = Number(valueWithDecimals).toLocaleString('cs');
        if (props.showDecimals && result.indexOf(',') === -1) {
            result +=',0';
        } else if (value.endsWith(",")) {
            // The user added "," manually...
            result +=",";
        } else if (value.endsWith(",0")) {
            result +=",0";
        }

        if (result === "0") {
            result = value;
        }
        observable[field] = result;
    }

    const computeThis = action(() => {
        props.observable.computing = props.field;
        props.observable.error = false;
    })

    let disabled = observable({value: props.observable.computing === props.field || props.disabled});

    function tooltipsSection() {
        return <>
            <ReactTooltip
                id="button-tooltip"
                place="top"
                content={props.buttonTooltip ?? "Počítat tento parametr"}
                className="tooltip"
            />
        </>
    }

    const rangeRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        updateSliderBackground(rangeRef.current);
        const newFieldValue = props.observable[props.field];
        if (textInputRef.current && textInputRef.current.value !== newFieldValue) {
            textInputRef.current.value = newFieldValue;
        }
    }, [props.observable[props.field]]);

    function updateSliderBackground(el: HTMLInputElement | null) {
        if (!el) return;
    
        const min = Number(el.min ?? 0);
        const max = Number(el.max ?? 100);
        const val = Number(el.value);
    
        const pct = ((val - min) / (max - min)) * 100;
    
        // Left = blue, Right = gray
        const fillColor = '#2563eb'; // Tailwind blue-600
        const trackColor = '#e5e7eb'; // Tailwind gray-300

        // I need to extract the secondary and primary colors from the variables in the :root element
        const r = document.querySelector(':root') as HTMLElement;
        const secondaryColor = r.style.getPropertyValue('--secondary-color');
        const primaryColor = r.style.getPropertyValue('--primary-color');
        el.style.background = `linear-gradient(to right, ${secondaryColor}, ${primaryColor})`;
    }

    return (<>
        <div
            className={`input-with-slider print-hidden inline-flex flex-col w-[185px] ${disabled.value && props.observable.error ? 'error' :''}`}
        >
            {disabled.value ? <>
                {props.observable.error ? <>
                    <div className='input-error-message min-w-[150px]'>
                        {props.observable.error? (props.errorMessage ? props.errorMessage : 'Nelze spočítat') : props.observable[props.field]}
                    </div>
                </>:<>
                    <span className='input-wrapper disabled flex flex-row'>
                        <input
                            className='w-[150px] rounded-[5px] border border-gray-500 leading-5 pl-2.5 mb-1.5'
                            type='text'
                            placeholder={props.placeholder}
                            disabled={true}
                            value={props.observable[props.field]}
                            onChange={(e) => {}}
                        >
                        </input>
                        {props.textAfterInput && 
                            <span className='text-after-input ml-1.5 text-lg font-medium pb-1.5'>
                                {props.textAfterInput}
                            </span>
                        }
                    </span>    

                    <span className='input-misc flex flex-row'>
                        {!props.dontShowSlider &&
                            <input
                                type='range'
                                min={props.min}
                                max={props.max}
                                step={props.step}
                                value={Number(props.observable[props.field].replace(/\s/g, '').replace(/,/g, '.'))}
                                onChange={(e) => {}}
                                disabled={disabled.value}
                                className='input-slider w-[158px] rounded-[5px]'
                                ref={rangeRef}
                            >
                            </input>
                        }
                    </span>
                </>}


                    {/*

                    <span>
                        {props.observable.error? (props.errorMessage ? props.errorMessage : 'Nelze spočítat') : props.observable[props.field]}
                    </span>
                    {props.textAfterInput && !props.observable.error &&
                        <span className='text-after-input'>
                            {props.textAfterInput}
                        </span>
                    }
                    */}
                
            </> : <>
                <span className='input-wrapper flex flex-row'>
                    <input
                        ref={textInputRef}
                        type='text'
                        placeholder={props.placeholder}
                        defaultValue={props.observable[props.field]}
                        onBlur={(e) => onBlur(e, props.observable, props.field)}
//                        onChange={(e) => changeValue(e, props.observable, props.field)}
                        disabled={props.disableNumericalInput}
                        className='w-[150px] rounded-[5px] border border-gray-500 leading-5 pl-2.5 mb-1.5'
                    >
                    </input>
                    {props.textAfterInput && 
                        <span className='text-after-input ml-1.5 text-lg font-medium pb-1.5'>
                            {props.textAfterInput}
                        </span>
                    }          
                </span>

                <span className='input-misc flex flex-row'>
                    {!props.dontShowSlider &&
                        <input
                            type='range'
                            min={props.min}
                            max={props.max}
                            step={props.step}
                            value={Number(props.observable[props.field].replace(/\s/g, '').replace(/,/g, '.'))}
                            onChange={(e) => changeValue(e, props.observable, props.field)}
                            disabled={disabled.value}
                            className='input-slider w-[158px] rounded-[5px]'
                            ref={rangeRef}
                        >
                        </input>
                    }
                    {(props.observable.computing && !props.disableBtn && props.observable.computing !== props.field) &&
                        <Calculator
                            onClick={() => computeThis()} className='icon cursor-pointer self-center'
                            data-tooltip-id="button-tooltip"
                        />
                    }
                </span>
            </>}
        </div>
        <span className="print-visible">
            {props.observable[props.field]}
            {props.textAfterInput && 
                <span className='text-after-input ml-1.5'>
                    {props.textAfterInput}
                </span>
            }
        </span>
        {tooltipsSection()}
    </>)
})